
import { useState } from 'react';

interface Proveedor {
    id: string;
    nombre: string;
}

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (providerId: string) => void;
    proveedores: Proveedor[];
}

export default function GenerarOrdenCompraModal({ isOpen, onClose, onConfirm, proveedores }: Props) {
    const [selectedProvider, setSelectedProvider] = useState<string>('');

    if (!isOpen) return null;

    const handleConfirm = () => {
        if (selectedProvider) {
            onConfirm(selectedProvider);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
                <h2 className="text-xl font-bold text-slate-800 mb-4">Generar Orden de Compra</h2>
                <p className="text-slate-600 mb-4 text-sm">
                    Seleccione el proveedor al cual se le asignará la compra y se generará la Orden de Compra.
                </p>

                <div className="space-y-3 mb-6">
                    {proveedores.map((provider) => (
                        <label
                            key={provider.id}
                            className={`flex items-center p-3 rounded-lg border cursor-pointer transition-colors ${selectedProvider === provider.id
                                    ? 'border-teal-500 bg-teal-50'
                                    : 'border-slate-200 hover:bg-slate-50'
                                }`}
                        >
                            <input
                                type="radio"
                                name="provider"
                                value={provider.id}
                                checked={selectedProvider === provider.id}
                                onChange={(e) => setSelectedProvider(e.target.value)}
                                className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-slate-300"
                            />
                            <span className="ml-3 text-sm font-medium text-slate-700">
                                {provider.nombre}
                            </span>
                        </label>
                    ))}
                    {proveedores.length === 0 && (
                        <p className="text-sm text-red-500 italic">No hay proveedores asignados a esta cotización.</p>
                    )}
                </div>

                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-sm font-medium text-slate-700 bg-slate-100 rounded-lg hover:bg-slate-200"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleConfirm}
                        disabled={!selectedProvider}
                        className="px-4 py-2 text-sm font-medium text-white bg-teal-500 rounded-lg hover:bg-teal-600 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Generar Orden
                    </button>
                </div>
            </div>
        </div>
    );
}
